import React, { useState } from "react";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import "./styles/searchbar.css";


const renderSearchbar = ( value, setValue, focused, setFocused, suggestions = [], hoverIndex, setHoverIndex, handleSelect ) => {
  const isEmpty = value.trim() === "";
  const filteredSuggestions = suggestions.filter((s) =>
    s.toLowerCase().includes(value.toLowerCase())
  );

  const groupClass = [
    "searchbarContainer",
    isEmpty ? "is-empty" : "is-filled",
    focused ? "is-focused" : ""
  ].join(" ").trim();

  return (
    <div className={groupClass} >
      <SearchOutlined className="leftIcon" />
      <input
        value={value}
        placeholder="Search"
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setTimeout(() => setFocused(false), 150);
        }}
      />
      {!isEmpty ? (
        <button
          onClick={() => {
            setValue("");
          }}
        >
          <CloseOutlined />
        </button>
      ) : null}
      {focused && filteredSuggestions.length > 0 && (
        <ul 
          className="suggestionsList" 

        >
          {filteredSuggestions.map((item, index) => (
            <li
              key={index}
              className={hoverIndex === index ? "active" : ""}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(-1)}
              onClick={() => handleSelect(item)}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

/**
 * Componente de barra de búsqueda con autocompletado.
 *
 * @componen
 * @param {string} value - Valor actual del input de búsqueda.
 * @param {function(string):void} setValue - Función para actualizar el valor del input.
 * @param {string[]} [suggestions=[]] - Lista de sugerencias disponibles para autocompletar.
 * @returns {JSX.Element|null} Componente JSX de la barra de búsqueda o `null` si faltan props requeridas.
 *
 * @example
 * const [searchValue, setSearchValue] = useState("");
 * <Searchbar value={searchValue} setValue={setSearchValue} suggestions={["Apple", "Banana", "Cherry"]} />
 */
const Searchbar = ({ value, setValue, suggestions }) => {
  const [focused, setFocused] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(-1);

  const handleSelect = (item) => {
    setValue(item);
    setFocused(false);
  };

  return (typeof value === "undefined" || typeof setValue === "undefined") ? console.error( "At least one of the required parameters value or setValue props are missing in Searchbar component. Add them to use the Searchbar. (See React hook useState for setters).") : 
    renderSearchbar( value, setValue, focused, setFocused, suggestions, hoverIndex, setHoverIndex, handleSelect );
};

export default Searchbar;